/* Luniella custom box: a small adapter around the theme's existing cart.
 * Theme UX rules only; not a server-side checkout validation function.
 */
(function () {
  'use strict';
  const configNode = document.getElementById('luniella-box-config');
  if (!configNode) return;
  const config = JSON.parse(configNode.textContent);
  const eligible = new Set(config.eligibleVariants.map(Number));
  const excluded = new Set(config.excludedVariants.map(Number));
  const root = config.root.replace(/\/$/, '') + '/';
  let latest = null;
  let sequence = Promise.resolve();
  let checkoutPass = false;
  const activeForms = new WeakSet();
  const money = value => new Intl.NumberFormat('ar', {
    style: 'currency', currency: config.currency || 'ILS', maximumFractionDigits: 2
  }).format(value / 100);
  function serial(task) {
    const next = sequence.then(task, task);
    sequence = next.catch(function () {});
    return next;
  }
  function isBox(item) { return Number(item.product_id) === Number(config.boxProductId); }
  function isContent(item) {
    return !isBox(item) && !excluded.has(Number(item.variant_id)) &&
      (eligible.has(Number(item.variant_id)) || (item.properties || {})._luniella_box === 'custom');
  }
  async function api(path, payload) {
    const options = {method: payload ? 'POST' : 'GET', credentials: 'same-origin', cache: 'no-store', headers: {Accept: 'application/json'}};
    if (payload) { options.headers['Content-Type'] = 'application/json'; options.body = JSON.stringify(payload); }
    const response = await fetch(root + path, options);
    let result;
    try { result = await response.json(); } catch (_) { throw new Error('تعذّر الاتصال بالسلة. حدّثي الصفحة وحاولي مجددًا.'); }
    if (!response.ok || result.status) {
      throw new Error(result.description || result.message || 'تعذّر تحديث البوكس. حاولي مجددًا.');
    }
    return result;
  }
  function remember(cart) { latest = cart; render(cart); return cart; }
  async function normalize(cart) {
    const contents = cart.items.filter(isContent);
    const boxes = cart.items.filter(isBox);
    const updates = {};
    boxes.forEach(function (item, index) {
      const quantity = contents.length && index === 0 ? 1 : 0;
      if (item.quantity !== quantity) updates[item.key] = quantity;
    });
    if (Object.keys(updates).length) cart = await api('cart/update.js', {updates: updates});
    if (contents.length && !boxes.length) {
      await api('cart/add.js', {items: [{id: config.boxId, quantity: 1, properties: {_luniella_box: 'packaging'}}]});
      cart = await api('cart.js');
    }
    return remember(cart);
  }
  async function refresh(cart) {
    remember(cart);
    if (window.Cart && typeof window.Cart.update === 'function') await window.Cart.update();
    // A cart with its last content removed also loses its packaging line.
    document.querySelectorAll('.cart-mini-full').forEach(function (el) {
      el.classList.toggle('visible', cart.item_count > 0);
    });
    document.querySelectorAll('.cart-mini-empty').forEach(function (el) {
      el.classList.toggle('visible', cart.item_count === 0);
    });
    render(cart);
  }
  function error(message) {
    const slots = document.querySelectorAll('[data-lb-error]');
    slots.forEach(function (el) { el.textContent = message; el.hidden = !message; });
    let toast = document.getElementById('lb-status');
    if (!toast && document.body) {
      toast = document.createElement('div');
      toast.id = 'lb-status'; toast.className = 'lb-toast';
      toast.setAttribute('role', 'alert'); toast.setAttribute('dir', 'rtl');
      document.body.appendChild(toast);
    }
    if (toast) { toast.textContent = message; toast.hidden = !message; }
  }
  function formKind(form) {
    const marker = form && form.querySelector('[data-luniella-eligible]');
    if (marker && marker.dataset.luniellaBoxProduct === 'true') return 'box';
    if (marker && marker.dataset.luniellaEligible === 'true') return 'content';
    const input = form && form.querySelector('[name="id"]');
    if (input && Number(input.value) === Number(config.boxId)) return 'box';
    return input && eligible.has(Number(input.value)) && !excluded.has(Number(input.value)) ? 'content' : 'ordinary';
  }
  function parseItem(data) {
    const item = {id: Number(data.get('id')), quantity: Number(data.get('quantity') || 1), properties: {_luniella_box: 'custom'}};
    if (!item.id || !Number.isInteger(item.quantity) || item.quantity < 1) throw new Error('اختاري النوع والكمية أولًا.');
    if (data.get('selling_plan')) item.selling_plan = data.get('selling_plan');
    for (const pair of data.entries()) {
      const match = pair[0].match(/^properties\[(.+)\]$/);
      if (match) {
        if (typeof pair[1] !== 'string') throw new Error('إرفاق الملفات غير مدعوم في تجميع البوكس حاليًا.');
        item.properties[match[1]] = pair[1];
      }
    }
    item.properties._luniella_box = 'custom';
    return item;
  }
  async function add(data, form) {
    if (activeForms.has(form)) throw new Error('جارٍ إضافة القطعة، انتظري لحظة.');
    activeForms.add(form);
    try {
      return await serial(async function () {
        error('');
        const kind = formKind(form);
        if (kind === 'box') throw new Error('ابدئي باختيار محتويات بوكسك من صفحة «صمّمي بوكسك».');
        if (kind === 'ordinary') {
          const response = await fetch(root + 'cart/add.js', {method: 'POST', body: data, credentials: 'same-origin', headers: {Accept: 'application/json'}});
          if (response.ok) await normalize(await api('cart.js'));
          return response;
        }
        const cart = await api('cart.js');
        const boxes = cart.items.filter(isBox);
        const items = [parseItem(data)];
        if (!boxes.length) {
          if (!config.boxAvailable) throw new Error('بوكس لونيلا غير متوفر حاليًا. تواصلي معنا لإتمام طلبك.');
          items.push({id: config.boxId, quantity: 1, properties: {_luniella_box: 'packaging'}});
        }
        const result = await api('cart/add.js', {items: items});
        await normalize(await api('cart.js'));
        return {json: async function () { return result.items[0]; }};
      });
    } catch (err) { error(err.message); throw err; }
    finally { activeForms.delete(form); }
  }
  function change(key, quantity) {
    return serial(async function () {
      error('');
      let cart = await api('cart.js');
      const item = cart.items.find(function (entry) { return entry.key === key; });
      // Ignore duplicate callbacks from a stale cart row.
      if (!item) return remember(cart);
      if (isBox(item) && cart.items.some(isContent)) quantity = 1;
      cart = await api('cart/change.js', {id: key, quantity: Number(quantity)});
      cart = await normalize(cart);
      await refresh(cart);
      return cart;
    });
  }
  function render(cart) {
    if (!document.body) return;
    const contents = cart.items.filter(isContent);
    const count = contents.reduce(function (sum, item) { return sum + item.quantity; }, 0);
    const packaging = cart.items.filter(isBox);
    const total = contents.concat(packaging).reduce(function (sum, item) { return sum + item.final_line_price; }, 0);
    const text = 'عدد القطع: ' + count + ' · ' + money(total);
    document.querySelectorAll('[data-lb-cart-guide], [data-lb-summary]').forEach(function (el) { el.hidden = !count; });
    document.querySelectorAll('[data-lb-cart-summary], [data-lb-summary-text]').forEach(function (el) { el.textContent = text; });
    document.body.classList.toggle('lb-has-box', count > 0);
    document.querySelectorAll('[data-luniella-eligible="true"] [data-product-inline-atc-text]').forEach(function (el) { el.textContent = 'أضيفي لبوكسك'; });
    document.querySelectorAll('[data-luniella-eligible="true"]').forEach(function (button) {
      if (!button.disabled) {
        const label = button.querySelector('[data-product-inline-atc-text]');
        if (label) label.textContent = 'أضيفي لبوكسك';
      }
    });
  }
  async function checkCheckout() {
    return serial(async function () {
      const before = await api('cart.js');
      const cart = await normalize(before);
      if (!cart.item_count) throw new Error('اختاري محتويات بوكسك أولًا.');
      return cart;
    });
  }
  window.LuniellaBox = {add: add, change: change, error: error};
  // Intercept a normal form submit (Enter key / alternate native submit).
  document.addEventListener('submit', function (event) {
    const form = event.target;
    if (!(form instanceof HTMLFormElement)) return;
    if (form.matches('form[action*="/cart/add"]') && formKind(form) !== 'ordinary') {
      event.preventDefault(); event.stopImmediatePropagation();
      if (!form.reportValidity()) return;
      add(new FormData(form), form).then(async function () {
        await refresh(latest);
        const cartButton = document.querySelector('[data-site-actions-cart]');
        if (cartButton) cartButton.click();
        else location.assign(root + 'cart');
      }).catch(function (err) { error(err.message); });
    }
  }, true);
  // Honor existing terms and form validation; re-submit through the same button.
  document.addEventListener('click', function (event) {
    const button = event.target.closest('[name="checkout"]');
    if (!button || button.disabled || checkoutPass) return;
    event.preventDefault(); event.stopImmediatePropagation();
    const form = button.form;
    if (!form || !form.reportValidity()) return;
    button.disabled = true;
    checkCheckout().then(function () {
      button.disabled = false; checkoutPass = true;
      try { form.requestSubmit(button); } finally { checkoutPass = false; }
    }).catch(function (err) { button.disabled = false; error(err.message); });
  }, true);
  // Block Enter-driven checkout too, without changing non-checkout cart submits.
  document.addEventListener('submit', function (event) {
    if (checkoutPass || !event.target.matches('.cart-form')) return;
    const button = event.submitter || event.target.querySelector('[name="checkout"]');
    if (!button || button.name !== 'checkout') return;
    event.preventDefault(); event.stopImmediatePropagation();
    if (!button.disabled) button.click();
  }, true);
  function init() {
    serial(async function () {
      const before = await api('cart.js');
      const cart = await normalize(before);
      if (JSON.stringify(before.items) !== JSON.stringify(cart.items)) await refresh(cart);
    }).catch(function (err) { error(err.message); });
    document.addEventListener('cartItems', function () { if (latest) render(latest); });
    document.addEventListener('product-variant-switch', function () { if (latest) setTimeout(function () { render(latest); }, 0); });
    window.addEventListener('pageshow', function (event) {
      if (event.persisted) serial(async function () { await refresh(await normalize(await api('cart.js'))); }).catch(function (err) { error(err.message); });
    });
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
  else init();
})();
